export default __webpack_public_path__ + "static/media/breakfree.dc0649c3.png";